export const isNull = (obj: unknown): obj is null => obj === null && typeof obj === 'object';
export const isNotNull = <T>(obj: T | null): obj is T => !isNull(obj);

export const isUndefined = (obj: unknown): obj is undefined => typeof obj === 'undefined';
export const isNotUndefined = <T>(obj: T | undefined): obj is T => !isUndefined(obj);

export const isNotPresent = (obj: unknown): obj is null | undefined => isNull(obj) || isUndefined(obj);
export const isPresent = <T>(obj: T | undefined | null): obj is T => !isNotPresent(obj);

export const isArray = (arr: unknown): arr is unknown[] => Array.isArray(arr);
export const isBoolean = (obj: unknown): obj is boolean => isPresent(obj) && typeof obj === 'boolean';
export const isDate = (obj: unknown): obj is Date => isPresent(obj) && obj instanceof Date;
// eslint-disable-next-line @typescript-eslint/ban-types
export const isFunction = (func: unknown): func is Function => isPresent(func) && func instanceof Function;
export const isNumber = (obj: unknown): obj is number => isPresent(obj) && typeof obj === 'number';
// eslint-disable-next-line @typescript-eslint/ban-types
export const isObject = (obj: unknown): obj is object =>
  isPresent(obj) && typeof obj === 'object' && !Array.isArray(obj);
export const isString = (obj: unknown): obj is string => isPresent(obj) && typeof obj === 'string';
export const isPrimitive = (obj: unknown): obj is boolean | number | string =>
  isBoolean(obj) || isNumber(obj) || isString(obj);
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const isPromise = (obj: any): obj is Promise<unknown> => isPresent(obj) && isFunction(obj.then);

export interface Indexed<T> {
  [id: string]: T;
}

export type DeepPartial<T> = { [P in keyof T]?: DeepPartial<T[P]> };
